$(document).ready(function() {
	// circle-bg desc 높이 맞춤
	
  $(window).load(function() {
	 	if( $('.circle_intro').length > 0 ) {
	 		$(window).on('resize.circle_intro',circle_intro_resize);		
	 		circle_intro_resize();
	 	}
	 });
/*   if( $('.circle_intro').length > 0 ) {
	 	$(window).on('resize',circle_intro_resize);
	}
 */

/* 	var colItemH = $(".circle_intro .desc").trpColItemH(5);
	$(window).resize(function(){ 
		var _change_width = window.innerWidth;      
		if( _change_width <= 1200 ){  
			colItemH.setCol(2);
		}else { 
			colItemH.setCol(5);
		}
		console.log(colItemH._arr_temps);
	});
	$(window).trigger("resize"); */


});

function circle_intro_resize() {
	//console.log("==============coll==============")
	$('.circle_intro').each(function() {

		var ch = $(this).find('.circle_intro-box .desc'), height = 0;
		ch.height('auto');
		ch.each(function() {
			height = ( height > $(this).outerHeight() ) ? height : $(this).outerHeight();
		});
		ch.outerHeight(height);
/* 
		if( $(window).width() > 1023 ) {
			ch.each(function() {
				height = ( height > $(this).outerHeight() ) ? height : $(this).outerHeight();
			});
			ch.outerHeight(height);
		}else{ // mobile
			if( !$(this).find('.circle_intro-box').hasClass("sm") ){
				if($(this).hasClass("has-2")){ 
					ch.each(function() {
						height = ( height > $(this).outerHeight() ) ? height : $(this).outerHeight();
					});
					ch.outerHeight(height);
					return;
				}

				ch.css({ height : "auto", "min-height":"auto"})
			}
		}
 */

	})

}